/* istanbul ignore file */
import React, { useEffect, useState } from 'react';
import { FieldProps, EnumField } from 'framework/ui/field';
import usePresaleOutputService from '../presaleOutputService';

const PositionEnumField = ({ ...props }: FieldProps) => {
  const [options, setOptions] = useState<Dictionary<string>>({});
  const { getPositionOptions } = usePresaleOutputService();

  useEffect(() => {
    (async () => {
      const positions = await getPositionOptions();

      setOptions(positions);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <EnumField options={options} {...props} />;
};

export default PositionEnumField;
